import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CCJensenForm from './pages/CCJensenForm';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import SubmissionsPage from './pages/SubmissionsPage';
import UserManagement from './pages/UserManagement';
import SubmissionDetail from './pages/SubmissionDetail';
import ArchivedSubmissions from './pages/ArchivedSubmissions';
import NotFound from './pages/NotFound';
import Hire from './pages/Hire';
import Footer from './components/Footer';
import { useAnalytics } from './hooks/useAnalytics';

// Analytics wrapper component that needs to be inside Router
function AppContent() {
  useAnalytics(); // This will automatically track page views

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="flex-grow">
        <Routes>
          <Route path="/" element={<CCJensenForm />} />
          <Route path="/hire" element={<Hire />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/submissions" element={<SubmissionsPage />} />
          <Route path="/admin/submissions/:id" element={<SubmissionDetail />} />
          <Route path="/admin/users" element={<UserManagement />} />
          <Route path="/admin/archived-submissions" element={<ArchivedSubmissions />} />
          <Route path="/admin/archived-submissions/:id" element={<SubmissionDetail />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
